<template>
  <main id="home">
    <b-row>
      <b-col>
        <h1>{{ $t('navbar.greeting') }} {{ user.nome }}</h1>
      </b-col>
    </b-row>

    <b-row> </b-row>

    <b-modal
      id="modal-descontinuacao"
      title="Aviso Importante"
      centered
      ok-only
      ok-variant="success"
      ok-title="Entendi"
      title-class="font-18"
    >
      <p>Prezado usuário,</p>
      <p>
        Esse portal será descontinuado a partir de <strong>31/07/2026</strong>. Clique <a href="https://linktr.ee/app.libra" target="_blank" rel="noopener noreferrer"
          >aqui</a> para acessar nosso novo
        Portal Web ou baixar o Aplicativo Libra Energia. Tenha acesso aos dados de consumo, relatórios, histórico financeiro e muito mais na palma
        da sua mão.
      </p>
    </b-modal>
  </main>
</template>

<style scoped>
.limit-width {
  display: inline-block;
  max-width: 450px;
  margin-right: 20px;
}
</style>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapState } = createNamespacedHelpers('auth');

export default {
  name: 'Home',
  data() {
    return {
      title: 'Dashboard',
      chartOptions: {
        series: [
          {
            data: [1, 2, 3]
          }
        ]
      }
    };
  },
  computed: {
    ...mapState(['user'])
  },
  mounted() {
    this.$bvModal.show('modal-descontinuacao');
  }
};
</script>
